'use client';

import { utilIntersectionObserver } from '@/fo/util/intersection-observer';

export interface UiKitAnimationBaseProps {
  children?: React.ReactNode;
}

export function UiKitAnimationBase({ children }: UiKitAnimationBaseProps) {
  const { ref, isIntersecting } = utilIntersectionObserver({
    root: null,
    rootMargin: '0px',
    threshold: 0.3,
    once: true
  });

  return (
    <div
      ref={ref}
      className={`animate-on-scroll ${isIntersecting ? 'is-visible' : ''}`}
    >
      {children}
    </div>
  );
}
